/**
 * The stakeholders board, as it was, with the service provider contracts
 * beneath it. The board shows how each party is performing; the register is
 * what each has agreed to do.
 */
import { Dashboard } from "../../demo/boards/Dashboard";
import { ContractsRegister } from "./ContractsRegister";

export function StakeholdersScreen() {
  return (
    <>
      <Dashboard view="stake" />
      <ContractsRegister />
    </>
  );
}
